import { BOOK_BASE } from '../../utils/constants'
import Button from '../app/design/Button'
import { ListHeader } from '../common/ListHeader'
import { WorkflowPage } from '../workflows/WorkflowPage'

export const PrivacyAndTermsPage = () => {
    return (
        <div className="flex flex-col items-center px-8 py-6">
            <div className="w-full max-w-[744px]">
                <ListHeader
                    title="Terms & privacy"
                    backButton={{
                        label: 'Settings',
                        href: '/settings',
                    }}
                />
                <div className="mt-6 rounded-lg">
                    <WorkflowPage.Card>
                        <WorkflowPage.IconSection
                            title="Privacy policy"
                            icon="shieldLock.large"
                            description="View the PocketSuite privacy policy"
                            secondaryView={
                                <Button
                                    intent="tertiaryLink"
                                    size="small"
                                    rightIcon="externalLink.small"
                                    onClick={() => window.open(`${BOOK_BASE}/privacy/`, '_blank')}
                                >
                                    View
                                </Button>
                            }
                            hasHoverEffect
                        />

                        <WorkflowPage.IconSection
                            title="Terms of service"
                            icon="documentLock.large"
                            description="View the PocketSuite terms of service"
                            secondaryView={
                                <Button
                                    intent="tertiaryLink"
                                    size="small"
                                    rightIcon="externalLink.small"
                                    onClick={() =>
                                        window.open(`${BOOK_BASE}/terms-service/`, '_blank')
                                    }
                                >
                                    View
                                </Button>
                            }
                            hasHoverEffect
                        />
                    </WorkflowPage.Card>
                </div>
            </div>
        </div>
    )
}
